module.exports = __webpack_public_path__ + "assets/chevron-right-white.7daafe7e.svg";